import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PortalService } from '../../../../../services/portal.service';

@Component({
  selector: 'app-address-validation',
  templateUrl: './address-validation.component.html',
  styleUrl: './address-validation.component.scss'
})
export class AddressValidationComponent {
  address: any;

  constructor(
    private portalService: PortalService,
    public dialogRef: MatDialogRef<AddressValidationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.address = this.getFullAddress(data.address1, data.address2, data.city, data.state, data.zip);
  }

  getFullAddress(line1: string, line2: string, city: string, stateCode: string, zipCode: string) {
    let address = "";
    if (line1) address += line1;
    if (line2) address += ", " + line2;
    if (city) address += ", " + city;
    if (stateCode) address += ", " + stateCode;
    if (zipCode) address += ", " + zipCode;
    return address;
  }

  close(isConfirm: boolean): void {
    this.dialogRef.close(isConfirm);
  }
}
